<div class="demo-section k-content">
  <input id="app-autocomplete-{{id}}" name="" class="form-control">
</div>
